/* eslint-disable */
(function ($) {
  // parseUri 1.2.2
  // (c) Steven Levithan <stevenlevithan.com>
  // MIT License
  function parseUri(str) {
    const o = parseUri.options;
    const m = o.parser[o.strictMode ? 'strict' : 'loose'].exec(str);
    const uri = {};
    let i = 14;
    while (i--) uri[o.key[i]] = m[i] || '';
    uri[o.q.name] = {};
    uri[o.key[12]].replace(o.q.parser, ($0, $1, $2) => {
      if ($1) uri[o.q.name][$1] = $2;
    });
    return uri;
  }

  parseUri.options = {
    strictMode: false,
    key: ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'],
    q: {
      name: 'queryKey',
      parser: /(?:^|&)([^&=]*)=?([^&]*)/g,
    },
    parser: {
      strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
      loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
    },
  };

  if (!azdsDefaultSettings.isBookingEngineEnabled) {
    handleReserveButtonOnDisabledBookingEngineIntegration();
  }

  function handleReserveButtonOnDisabledBookingEngineIntegration() {
    $(window).on('load', () => {
      parseUri.options.strictMode = true;
      const urlString = window.location.href;
      const url = parseUri(window.location.href);
      if (parseInt(url.queryKey.reserve) === 1) {
        openReserveOverlay();
        closeLeftSidebarMenu();
        closeHamburger();
        return false;
      }
    });
    $(document).on('click', '.reserve__button', function (event) {
      $(this).blur();
      event.preventDefault();
      openReserveOverlay();
      closeLeftSidebarMenu();
      closeHamburger();
      return false;
    });
    $(document).on('click', '.reserve__cross', function (event) {
      $(this).blur();
      event.preventDefault();
      closeReseveOverlay();
      closeLeftSidebarMenu();
      closeHamburger();
    });
    $(document).on('click', '.pendry-check-availability', function (event) {
      const $form = $(this).closest('.menu-pendry__check-availability');
      const $property = $form.find('.menu-pendry__choose-location');
      event.preventDefault();

      if ($property.val() === '') {
        return false;
      }

      redirectToBookingPage($form, $property.val());
    });
    $(window).on('keydown', (event) => {
      if (event.keyCode === 13 && $(event.target).hasClass('menu-pendry__button')) {
        const $form = $(event.target).closest('.menu-pendry__check-availability');
        const $property = $form.find('.menu-pendry__choose-location');
        event.preventDefault();
        if ($property.val() === '') {
          return false;
        }
        redirectToBookingPage($form, $property.val());
      }
    });
    $(document).on('click tap', '.booking-widget__submit--property-1', (event) => {
      if ($(window).width() > 991) {
        return;
      }
      event.preventDefault();
      $('.reserve__button').trigger('click');
      return false;
    });
  }

  /**
     * Open reserve overlay
     * @return void
     */
  function openReserveOverlay() {
    const $overlay = $('.reserve-overlay');
    const $cross = $('.reserve__cross');

    $('.reserve__button').removeClass('open');
    $cross.addClass('open').focus();
    $overlay.addClass('reserve-overlay--open');
    $('html, body').addClass('overflow-hidden');
  }

  /**
     * Close reserve overlay
     * @return void
     */
  function closeReseveOverlay() {
    const $overlay = $('.reserve-overlay');
    const $button = $('.reserve__button');
    const $cross = $('.reserve__cross');

    $cross.removeClass('open');
    $button.addClass('open').focus();
    $overlay.removeClass('reserve-overlay--open');

    $('html, body').removeClass('overflow-hidden');
  }

  /**
     * Redirect to property's booking page
     * @param form
     * @param bookingUrl
     */
  function redirectToBookingPage(form, bookingUrl) {
    form.attr('action', bookingUrl.path);
    window.location.href = bookingUrl;
  }

  function closeLeftSidebarMenu() {
    const $menu = $('.menu');
    $menu.removeClass('menu--open');
  }

  function closeHamburger() {
    const $hamburger = $('.c-hamburger');
    const $itemFirst = $('.c-hamburger__item--first');
    const $itemSecond = $('.c-hamburger__item--second');
    const $itemThird = $('.c-hamburger__item--third');
    const $itemFourth = $('.c-hamburger__item--fourth');
    $hamburger.removeClass('c-hamburger--open');
    $itemFirst.removeClass('c-hamburger__item--first-open');
    $itemSecond.removeClass('c-hamburger__item--second-open');
    $itemThird.removeClass('c-hamburger__item--third-open');
    $itemFourth.removeClass('c-hamburger__item--fourth-open');
  }
}(jQuery));
/* eslint-enable */
